<template>
  <div class="topic-editor">
    <!--<div class="topic-types">
      <div class="type" :class="{active: topic.topic_type_id == item.id}" v-for="item in topic_types" :key="item.id" @click="selectType(item.id)">{{item.name}}</div>

    </div>-->

    <div>
      <el-radio-group v-model="topic.topic_type_id">
        <el-radio :label="1">词</el-radio>
        <el-radio :label="2">句子</el-radio>
        <el-radio :label="3">段落</el-radio>
        <el-radio :label="4">其他</el-radio>
      </el-radio-group>
    </div>
    <template v-if="topic.topic_type_id == 4">
      <el-table
        empty-text="No Data"
        :data="topic.article_references"
        stripe
        style="width: 100%;margin: 20px 0;"
      >
        <el-table-column prop="title" label="标题"></el-table-column>
        <!--<el-table-column prop="link" label="Link"></el-table-column>-->
        <el-table-column label="Action" align="center">
          <template slot-scope="scope">
            <el-button
              type="danger"
              size="mini"
              @click="removeArticle(scope.row)"
              icon="el-icon-delete"
            ></el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-form ref="articleForm" :model="articleForm" :rules="rules" label-width="80px">
        <el-form-item prop="title" label="标题">
          <el-input v-model="articleForm.title"></el-input>
        </el-form-item>
        <!--<el-form-item prop="link" label="Link">
	  <el-input v-model="articleForm.link"></el-input>
        </el-form-item>-->
        <el-form-item prop="body" label="内容">
          <el-input
            type="textarea"
            :autosize="{ minRows: 10, maxRows: 20}"
            v-model="articleForm.body"
          ></el-input>
        </el-form-item>
        <el-form-item prop="image" label="缩略图">
          <el-upload
            class="upload-demo"
            action="/images"
            :file-list="articleForm.image"
            :auto-upload="false"
            :on-change="onArticleIamgeChanged"
            :on-remove="onArticleIamgeRemoved"
            list-type="picture"
          >
            <el-button size="small" type="primary">上传缩略图</el-button>
            <div slot="tip" class="el-upload__tip">仅支持图片文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item>
          <el-button style="width:150px;" type="success" @click="createArticle">创建文章</el-button>
          <el-button style="width:150px;" type="primary" @click="done" :loading="done_loading">完成</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template v-else>
      <div class="video">
        <div
          class="block"
          :style="{backgroundColor: (topic.attach.quick_url || topic.attach.url) ? '#2e2d2e':'#fff'}"
        >
          <el-upload
            v-if="!(topic.attach.quick_url || topic.attach.url)"
            class="upload-demo"
            drag
            accept="video/mp4, video/*"
            :action="COURSE_UPLOAD_BASEURL"
            :headers="uploadHeaders"
            :data="{}"
            :before-close="handleClose"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              拖拽视频文件到此处，或
              <em>点击选择视频上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">仅支持视频文件</div>
          </el-upload>
          <div
            v-if="!(topic.attach.quick_url || topic.attach.url)"
            class="recommand-tool"
            style="font-size: 14px"
          >
            <p style="padding:10px">
              为了节省视频上传时间，推荐下载使用
              <strong>
                <a href="https://handbrake.fr/downloads.php">视频压缩工具</a>
              </strong>
            </p>
            <h4 style="font-size: 18px;margin-bottom:20px">下载</h4>
            <el-button size="small" icon="fa fa-windows" @click="download('win')">微软(windows)</el-button>
            <el-button size="small" icon="fa fa-apple" @click="download('mac')">苹果(macOS)</el-button>
          </div>
          <video
            v-if="(topic.attach.quick_url || topic.attach.url)"
            width="auto"
            ref="video"
            height="350px"
            controls
            :src="topic.attach.quick_url || topic.attach.url"
          ></video>
          <div class="video-script">
            <div
              v-for="(el,index) in previewScript"
              :key="index"
              class="text"
              :class="{active: previewTime >= el.start_point}"
            >
              <div class="pinyin">{{previewPinyin[index]}}</div>
              <div>{{el.script}}</div>
            </div>
          </div>
        </div>
      </div>

      <div
        style="margin:10px 0;display:flex;align-items:center"
        v-if="topic.attach.quick_url || topic.attach.url"
      >
        <div style="flex-grow: 1;">
          <el-switch v-model="topic.show_subtitle" active-text="显示拼音" inactive-text="隐藏拼音"></el-switch>
        </div>
        <el-button size="small" @click="turningPreviewAll(0)">整体预览</el-button>
        <el-button style="width:120px;" size="small" @click="reUpload">重新上传视频</el-button>
        <!--<el-button style="width:120px;" type="primary" size="small" @click="done">Done</el-button>-->
        <el-button
          style="width:120px;"
          type="primary"
          size="small"
          @click="done"
          :loading="done_loading"
        >完成</el-button>
      </div>

      <el-tabs
        v-if="topic.attach.quick_url || topic.attach.url"
        v-model="transcriptsTabName"
        type="card"
        addable
        closable
        @tab-add="addPart"
        @tab-remove="removeTranscripts"
      >
        <el-tab-pane
          v-for="(item,index) in topic.transcripts"
          :key="index + 1"
          :label="'闪卡 '+(index + 1)"
          :name="index + 1 +''"
        >
          <el-row>
            <el-col :span="24">
              <el-checkbox style="float:right" v-model="item.quizable">作为练习题</el-checkbox>
            </el-col>
          </el-row>
          <div class="part-content" v-show="!turningStatus[index]">
            <div class="labels">
              <div>中文</div>
              <div>拼音</div>
              <div>英文</div>
            </div>
            <div class="inputs">
              <div>
                <el-input
                  size="small"
                  v-model="topic.transcripts[index].script"
                  @change="onScriptChange(index,$event)"
                  type="text"
                ></el-input>
              </div>
              <div>
                <el-input
                  size="small"
                  v-model="topic.transcripts[index].pinyin"
                  @change="onPinyinChange(index,$event)"
                  type="text"
                ></el-input>
              </div>
              <div>
                <el-input size="small" v-model="topic.transcripts[index].english" type="text"></el-input>
              </div>
            </div>
            <div class="times">
              <p>{{topic.transcripts[index].start_point | toFixed | secondFormat}}</p>
              <p>{{topic.transcripts[index].end_point | toFixed | secondFormat}}</p>
            </div>
            <div class="buttons">
              <div>
                <el-button size="small" type="primary" @click="setStartPoint(index)">字幕起始时间点</el-button>
              </div>
              <div>
                <el-button size="small" type="primary" @click="setEndPoint(index)">字幕结束时间点</el-button>
              </div>
              <div>
                <el-button size="small" type="primary" @click="turningPreview(index)">字幕预览</el-button>
              </div>
              <div>
                <el-button size="small" type="primary" @click="toggleTurning(index)">字幕微调</el-button>
              </div>
            </div>
          </div>
          <div class="turning" v-if="turningStatus[index]">
            <div class="scripts">
              <div
                class="script-block"
                v-for="(el, index2) in topic.transcripts[index].scripts"
                :key="index2"
              >
                <div v-if="index2 == 0" class="time">
                  <div class="text">{{el.start_point | toFixed | secondFormat}}</div>
                </div>
                <div
                  class="text"
                  :class="{active: previewTime >= el.start_point && previewTime <= el.end_point }"
                >{{el.script}}</div>
                <div v-if="index2 != topic.transcripts[index].scripts.length - 1" class="time">
                  <span class="text">{{el.end_point | toFixed | secondFormat}}</span>
                  <vue-slider
                    ref="slider"
                    v-model="topic.transcripts[index].scripts[index2].end_point"
                    @callback="sliderChange(index,index2,$event)"
                    direction="vertical"
                    real-time
                    :min="slideRange(index,index2).min"
                    :max="slideRange(index,index2).max"
                    :interval="0.01"
                    :width="5"
                    :height="100"
                    :formatter="function(value){return value.toFixed(2)*1}"
                  ></vue-slider>
                </div>
                <div v-else class="time">
                  <div class="text">{{el.end_point | toFixed | secondFormat}}</div>
                </div>
              </div>
            </div>
            <div class="buttons">
              <el-button @click="turningPreview(index)">预览</el-button>
              <el-button @click="turningConfirm(index)">确认</el-button>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </template>
  </div>
</template>
<script>
import pinyin from "pinyin";
import { getCookie } from "tiny-cookie";
import { COURSE_UPLOAD_BASEURL } from "../common/config";
import vueSlider from "../components/vue2-slider";
import http from "../common/http";
import BigNumber from "bignumber.js";

export default {
  name: "topic-editor",
  props: {
    taskid: {
      type: String,
      default: ""
    },
    isNew: {
      type: Boolean,
      default: true
    },
    data: {
      type: Object,
      default: () => {
        ({});
      }
    }
  },
  watch: {
    isNew(newValue) {
      if (newValue == true) {
        this.topic = {
          id: "",
          topic_type_id: 1,
          show_subtitle: true,
          owner_id: "",
          owner_name: "",
          permission: "",
          attach: {
            url: ""
          },
          article_references: [],
          transcripts: [
            {
              quizable: true,
              script: "",
              pinyin: "",
              english: "",
              start_point: 0,
              end_point: 0,
              scripts: []
            }
          ]
        };
      } else {
        this.topic = this.data;
      }
    }
  },
  components: {
    vueSlider
  },
  data() {
    let init_topic = {};
    if (this.isNew) {
      init_topic = {
        id: "",
        topic_type_id: 1,
        show_subtitle: true,
        owner_id: "",
        owner_name: "",
        permission: "",
        attach: {
          url: "",
          quick_url: ""
        },
        article_references: [],
        transcripts: [
          {
            script: "",
            pinyin: "",
            english: "",
            start_point: 0,
            end_point: 0,
            scripts: []
          }
        ]
      };
    } else {
      init_topic = JSON.parse(JSON.stringify(this.data));
    }

    return {
      COURSE_UPLOAD_BASEURL,
      uploadHeaders: {
        "Access-Token": getCookie("access_token")
      },
      topic_types: [],
      turningStatus: [false],
      previewTime: 0,
      done_loading: false,
      topic: init_topic,
      deletedScript: [],
      deletedArticle: [],
      topicForm: {
        topic_type_id: "",
        video_id: "",
        show_subtitle: true,
        transcripts: [],
        article_references: []
      },
      articleForm: {
        title: "",
        body: "",
        // link: "",
        images: [],
        images_attibutes: []
      },
      rules: {
        title: [{ required: true, message: "标题不能为空!" }],
        // link:[{required: true, message: 'The link cannot be empty!'},{ type: 'url', message: 'The link url is not correct!'}],
        body: [{ required: true, message: "内容不能为空!" }],
        images: [{ required: true, message: "缩略图不能为空!" }]
      },
      transcriptsTabName: "1",
      interval: null,
      previewScript: [],
      previewPinyin: []
    };
  },
  created() {
    if (this.topic.video) {
      this.topicForm.video_id = this.topic.video.id || "";
    }
  },
  methods: {
    download(os) {
      let url =
        os === "win"
          ? "https://handbrake.fr/rotation.php?file=HandBrake-1.0.7-x86_64-Win_GUI.exe"
          : "https://handbrake.fr/rotation.php?file=HandBrake-1.0.7.dmg";
      window.open(url, "_blank");
    },
    slideRange(index, index2) {
      let transciprt = this.topic.transcripts[index];
      let start_point = transciprt.start_point * 1;
      let end_point = transciprt.end_point * 1;

      let min = Math.max(
        new BigNumber(
          new BigNumber(end_point)
            .minus(start_point)
            .div(transciprt.scripts.length)
            .toFixed(2)
        )
          .mul(index2 + 1)
          .plus(start_point)
          .minus(0.3),
        start_point
      );
      let max = Math.min(
        new BigNumber(
          new BigNumber(end_point)
            .minus(start_point)
            .div(transciprt.scripts.length)
            .toFixed(2)
        )
          .mul(index2 + 1)
          .plus(start_point)
          .plus(0.3),
        end_point
      );
      return {
        max,
        min
      };
    },
    onArticleIamgeChanged(file, fileList) {
      this.articleForm.images = fileList;
    },
    onArticleIamgeRemoved(file, fileList) {
      this.articleForm.images = fileList;
    },
    removeTranscripts(targetName) {
      this.$confirm(`你确认删除卡片${targetName}?`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(() => {
          if (targetName == this.topic.transcripts.length) {
            this.transcriptsTabName = targetName - 1 + "";
          } else {
            this.transcriptsTabName = targetName;
          }
          if (this.topic.transcripts[targetName - 1].id) {
            this.topic.transcripts[targetName - 1]._destroy = true;
            this.deletedScript = this.deletedScript.concat(
              this.topic.transcripts.splice(targetName - 1, 1)
            );
          } else {
            this.topic.transcripts.splice(targetName - 1, 1);
          }
        })
        .catch(() => {});
    },
    reUpload() {
      this.$confirm(`你确认重新上传?`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(() => {
          this.topic.attach.url = "";
          this.topic.attach.quick_url = "";
        })
        .catch(() => {});
    },
    removeArticle(target) {
      this.$confirm(`你确认删除该文章?`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(() => {
          let index = this.topic.article_references.findIndex(el => {
            return el.article_id === target.article_id;
          });
          this.topic.article_references[index]._destroy = true;
          this.deletedArticle = this.deletedArticle.concat(
            this.topic.article_references.splice(index, 1)
          );
        })
        .catch(() => {});
    },
    createArticle() {
      this.$refs["articleForm"].validate(valid => {
        if (valid) {
          let formData = new FormData();
          formData.append("title", this.articleForm.title);
          // formData.append('link', this.articleForm.link);
          formData.append("body", this.articleForm.body);
          this.articleForm.images.forEach((el, index) => {
            formData.append("images_attributes[" + index + "][file]", el.raw);
          });

          let config = {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          };
          http
            .post("/articles", formData, config)
            .then(res => {
              this.topic.article_references.push({
                article_id: res.id,
                link: this.articleForm.link,
                title: this.articleForm.title
              });
              this.$refs["articleForm"].resetFields();
              document.querySelector(
                ".el-upload-list.el-upload-list--picture"
              ).innerHTML = "";
              this.$success("Article create success");
            })
            .catch(err => {
              this.$error(err);
            });
        }
      });
    },
    // fileChange(event){
    //   console.log(event.target.files)
    //   if(event.target.files.length > 0){
    //     this.articleForm.images_attibutes = event.target.files.length
    //   }
    //   this.articleForm.images_attibutes = event.target.files
    // },
    selectType(id) {
      this.topic.topic_type_id = id;
    },
    getTopicTypes() {
      this.$api.topic_types.list().then(data => {
        this.topic_types = data;
      });
    },
    handleClose(done) {
      this.$confirm("该视频正在被上传，你确认关闭它?")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    handleUploadSuccess(response, file, fileList) {
      this.topic.attach.url = response.file.url;
      this.topic.attach.quick_url = response.quick_url;
      this.topicForm.video_id = response.id;
      this.$emit("input", this.topic);
    },
    handleUploadError(err, file, fileList) {
      console.log(err);
    },
    done() {
      return new Promise((resolve, reject) => {
        this.done_loading = true;

        let stop = false;
        if (this.topic.topic_type_id != 4) {
          this.topic.transcripts.forEach((el, index) => {
            if (!el.script) {
              this.$alert(`请填写闪卡${index + 1}中文`, "提示", {
                confirmButtonText: "确定"
              });
              stop = true;
              return false;
            }

            if (!el.pinyin) {
              this.$alert(`请填写闪卡${index + 1}拼音`, "提示", {
                confirmButtonText: "确定"
              });
              stop = true;
              return false;
            }

            if (!el.english) {
              this.$alert(`请填写闪卡${index + 1}英文`, "提示", {
                confirmButtonText: "确定"
              });
              stop = true;
              return false;
            }
            if (el.end_point - el.start_point <= 0) {
              this.$alert(`请检查闪卡${index + 1}的起始时间`);
              stop = true;
              return;
            }
            if (el.scripts.length === 0) {
              this.toggleTurning(index, true);
            }
          });
        }


        if (stop) {
          this.done_loading = false;
          reject();
          return;
        }

        if (this.topic.id) {
          this.topicForm.topic_type_id = this.topic.topic_type_id;
          this.topicForm.show_subtitle = this.topic.show_subtitle;
          if (this.topic.topic_type_id == 4) {
            let arr = this.topic.article_references.concat(this.deletedArticle);
            this.topicForm.article_references_attributes = arr;
          } else {
            let arr = this.topic.transcripts.concat(this.deletedScript);
            this.topicForm.transcripts_attributes = arr;
          }
          this.$api.topics
            .save(this.topic.id, this.topicForm)
            .then(data => {
              this.$success("作业更新成功");
              this.$emit("success");
              this.done_loading = false;
              resolve();
            })
            .catch(err => {
              this.$error(err);
              this.done_loading = false;
              reject(err);
            });
        } else {
          this.topicForm.topic_type_id = this.topic.topic_type_id;
          this.topicForm.show_subtitle = this.topic.show_subtitle;
          if (this.topic.topic_type_id == 4) {
            if (this.topic.article_references.length == 0) {
              this.$warning("请创建文章");
              this.done_loading = false;
              reject();
              return;
            }
            this.topicForm.article_references_attributes = this.topic.article_references;
          } else {
            if (this.topic.transcripts.length == 0) {
              this.$warning("请创建闪卡");
              this.done_loading = false;
              reject();
              return;
            }
            if (!this.topicForm.video_id) {
              this.$warning("请上传视频");
              this.done_loading = false;
              reject();
              return;
            }
            this.topicForm.transcripts_attributes = this.topic.transcripts;
          }
          this.$api.topics
            .create(this.topicForm)
            .then(data => {
              this.$success("作业创建成功");
              if (this.taskid) {
                // bind
                this.$api.tasks
                  .topics_create(this.taskid, data.id)
                  .then(data => {
                    this.$success("作业绑定成功");
                    this.$emit("success");
                    resolve();
                    // window.location.reload();
                    // this.$router.push('/homework/topic')
                  })
                  .catch(err => this.$error(err));
              } else {
                this.$emit("success");
                resolve();
                // window.location.reload();
                // this.$router.push('/homework/topic')
              }

              this.done_loading = false;
            })
            .catch(err => {
              this.$error(err);
              this.done_loading = false;
              reject();
            });
        }
      });
    },
    turningPreviewAll(index) {
      this.transcriptsTabName = 1 + "";
      if (this.interval) {
        clearInterval(this.interval);
      }
      let option = this.topic.transcripts[index];
      this.previewScript = option.scripts;
      this.previewPinyin = option.pinyin.split(" ");
      this.$refs.video.currentTime = option.start_point;
      this.$refs.video.play();
      this.interval = setInterval(() => {
        if (this.getPoint() > option.end_point) {
          this.$refs.video.pause();
          clearInterval(this.interval);
          if (index < this.topic.transcripts.length) {
            let i = ++index;
            this.turningPreviewAll(i);
            this.transcriptsTabName = i + 1 + "";
            // this.toggleTurning(i);
          }
        }
        this.previewTime = this.getPoint();
      }, 50);
    },
    turningPreview(index) {
      if (this.interval) {
        clearInterval(this.interval);
      }
      let option = this.topic.transcripts[index];
      this.previewScript = option.scripts;
      this.previewPinyin = option.pinyin.split(" ");
      this.$refs.video.currentTime = option.start_point;
      this.$refs.video.play();
      this.interval = setInterval(() => {
        if (this.getPoint() > option.end_point) {
          this.$refs.video.pause();
          clearInterval(this.interval);
        }
        this.previewTime = this.getPoint();
      }, 50);
    },
    turningConfirm(index) {
      this.previewScript = [];
      this.$set(this.turningStatus, index, false);
    },
    beforeLeave(activeName, oldActiveName) {
      console.log(activeName, oldActiveName);
      const index = oldActiveName - 1;

      const {
        start_point,
        end_point,
        script,
        scripts,
        english,
        pinyin
      } = this.topic.transcripts[index];
      console.log(this.topic.transcripts);
      if (!script) {
        this.$alert("请填写中文", "提示", {
          confirmButtonText: "确定"
        });
        return false;
      }

      if (!pinyin) {
        this.$alert("请填写拼音", "提示", {
          confirmButtonText: "确定"
        });
        return false;
      }

      if (!english) {
        this.$alert("请填写英文", "提示", {
          confirmButtonText: "确定"
        });
        return false;
      }

      if (end_point - start_point === 0 || end_point === 0) {
        this.$alert("请设置起始时间", "提示", {
          confirmButtonText: "确定"
        });
        return false;
      }

      if (!scripts.length) {
        // this.toggleTurning(index, true)
        return false;
      }

      return true;
    },
    toggleTurning(index, notShowTurning, pinyinChanged) {
      let script = this.topic.transcripts[index].script
        .replace(/\s/g, "")
        .match(/([^\u4e00-\u9fa5]{1,})|([\u4e00-\u9fa5])/g);
      let start_point =
        (this.topic.transcripts[index].start_point * 1).toFixed(2) * 1;
      let end_point =
        (this.topic.transcripts[index].end_point * 1).toFixed(2) * 1;
      if (!script) {
        this.$alert("请输入中文");
        return;
      }
      if ((end_point == 0 && start_point == 0) || end_point < start_point) {
        this.$alert("请设置正确的开始和结束时间");
        return;
      }
      if (pinyinChanged && this.topic.transcripts[index].scripts) {
        const changedPinyin = this.topic.transcripts[index].pinyin.split(" ");
        changedPinyin.forEach((el, i) => {
          this.topic.transcripts[index].scripts[i].pinyin = el;
        });
        this.$set(this.topic.transcripts, index, this.topic.transcripts[index]);
        return;
      }
      if (
        this.topic.transcripts[index].scripts &&
        this.topic.transcripts[index].scripts.length > 0
      ) {
        this.$set(this.turningStatus, index, !this.turningStatus[index]);
        return;
      }
      let total_time = end_point - start_point;
      let pinyin = this.topic.transcripts[index].pinyin.split(" ");
      let default_time = (total_time / script.length).toFixed(2) * 1;

      let arr = [];
      script.forEach((el, i) => {
        arr.push({
          start_point: start_point + i * default_time,
          end_point: start_point + (i + 1) * default_time,
          script: el,
          pinyin: pinyin[i]
        });
      });

      this.topic.transcripts[index].scripts = arr;

      this.$set(this.topic.transcripts, index, this.topic.transcripts[index]);
      if (!notShowTurning) {
        this.$set(this.turningStatus, index, !this.turningStatus[index]);
      }
    },
    sliderChange(index, index2, value) {
      value = value.toFixed(2) * 1;
      this.topic.transcripts[index].scripts[index2 + 1].start_point = value;
      this.$set(this.topic.transcripts, index, this.topic.transcripts[index]);
    },
    addPart() {
      this.topic.transcripts.push({
        quizable: true,
        script: "",
        pinyin: "",
        english: "",
        start_point: 0,
        end_point: 0
      });
      this.turningStatus.push(false);
      this.transcriptsTabName = this.topic.transcripts.length + "";
    },
    onPinyinChange(index, value) {
      if (!value) {
        return;
      }
      this.topic.transcripts[index].pinyin = value;
      this.toggleTurning(index, true, true);
    },
    onScriptChange(index, value) {
      if (!value) {
        return;
      }
      this.topic.transcripts[index].pinyin = pinyin(value.replace(/\s/g, ""))
        .map(s => {
          return s[0].trim();
        })
        .join(" ");
      this.topic.transcripts[index].script = value.replace(/\s/g, "");
      this.topic.transcripts[index].scripts = [];
      if (
        this.topic.transcripts[index].end_point > 0 &&
        this.topic.transcripts[index].end_point >
          this.topic.transcripts[index].start_point
      ) {
        this.toggleTurning(index, true);
      }
      this.$set(this.topic.transcripts, index, this.topic.transcripts[index]);
    },
    setStartPoint(index) {
      this.$refs.video.play();
      this.topic.transcripts[index].start_point = this.getPoint();
      this.topic.transcripts[index].scripts = [];
      this.$set(this.topic.transcripts, index, this.topic.transcripts[index]);
    },
    setEndPoint(index) {
      this.topic.transcripts[index].end_point = this.getPoint();
      this.$refs.video.pause();
      this.topic.transcripts[index].scripts = [];
      this.$set(this.topic.transcripts, index, this.topic.transcripts[index]);
      if (this.topic.transcripts[index].script) {
        this.toggleTurning(index, true);
      }
    },
    getPoint() {
      return this.$refs.video.currentTime.toFixed(2) * 1;
    }
  },
  destroyed() {
    clearInterval(this.interval);
  }
};
</script>
<style lang="scss">
.topic-editor {
  .el-upload--text {
    border: none;
  }

  .topic-types {
    display: flex;

    .type {
      flex-grow: 1;
      padding: 10px;
      width: 0;
      text-align: center;
      font-size: 18px;
      cursor: pointer;
      transition: all 0.3s;
      border-bottom: 2px solid #409eff;

      &:hover,
      &.active {
        background-color: #409eff;
        color: #fff;
      }
    }
  }

  .video {
    display: flex;
    margin: 10px 0;

    .block {
      flex-grow: 1;
      position: relative;
      text-align: center;
      font-size: 0;

      .video-script {
        position: absolute;
        bottom: 50px;
        font-size: 20px;
        width: 100%;
        text-align: center;

        .text {
          transition: color 0.2s;
          color: #fff;
          display: inline-block;
          padding: 0 5px;

          .pinyin {
            font-size: 14px;
          }

          &.active {
            color: #ff2b2b;
          }
        }
      }
    }
  }

  .part {
    position: relative;
  }

  .part-content {
    display: flex;

    .el-input,
    .el-button {
      margin-bottom: 10px;
    }

    .labels {
      width: 70px;
      line-height: 32px;
      text-align: right;
      margin-right: 10px;

      & > div {
        margin-bottom: 10px;
      }
    }

    .inputs {
      flex: 1;
      flex-grow: 1;
    }

    .buttons {
      width: 120px;
      margin-left: 10px;

      .el-button {
        margin-left: 0;
        width: 100%;
      }
    }

    .times {
      margin-left: 10px;
      width: 120px;
      text-align: center;
      line-height: 32px;

      p {
        margin-bottom: 10px;
      }
    }
  }

  .turning {
    // position: absolute;
    margin-bottom: 40px;
    top: 0;
    left: 0;
    width: 100%;
    min-height: 100%;
    background-color: #fff;

    .scripts {
      margin: 10px 0;

      .script-block {
        display: inline-block;
        margin-right: 15px;
      }

      .vue-slider {
        margin: 0 auto;
      }

      .script-block .time {
        width: 50px;
        text-align: center;
        display: inline-block;
        vertical-align: top;

        .text {
          font-size: 12px;
          line-height: 50px;
        }
      }

      .script-block > .text {
        width: 50px;
        height: 50px;
        display: inline-block;
        font-size: 36px;
        line-height: 50px;
        text-align: center;
        border: 1px solid #ccc;

        &.active {
          color: #e60c0c;
        }
      }
    }
  }

  .el-tabs__nav-wrap.is-scrollable {
    padding: 0 40px;

    .el-tabs__nav-prev,
    .el-tabs__nav-next {
      border: 1px solid #efefef;
      padding: 0 13px;
    }
  }

  .el-tabs__header .el-tabs__new-tab {
    width: 120px;
    background-color: #67c23a;
    border: none;
    color: transparent;
    height: 32px;
    margin: 4px 0 0;
    position: relative;

    &::after {
      content: "新建闪卡";
      font-size: 14px;
      display: block;
      color: #fff;
      top: 50%;
      position: absolute;
      left: 50%;
      width: 100%;
      transform: translate(-50%, -50%);
    }
  }

  .el-radio__label {
    font-size: 16px;
  }
}
</style>
